import { useMemo } from 'react';

import { getRole } from 'services/UserService';

import { ROLES } from 'config/organization';

export const useRole = () => {
  return useMemo(() => getRole() ?? ROLES.defaultUser, []);
};
